import Sprite from "app/components/sprite";
import { useAnimation } from "app/hooks/useAnimation";
import handPhoneImg from "app/images/collections/hand-phone.png";
import { Trans } from "react-i18next";
import { useRef } from "react";

export const UseCasesSection = () => {
  const body = useRef(null);
  const image = useRef(null);

  useAnimation([body, image]);

  return (
    <section className="relative z-10 flex h-full justify-center bg-primary font-montserrat">
      <div className="absolute flex h-full w-full justify-center overflow-hidden">
        <div className="absolute h-full w-full max-w-sm md:max-w-[90rem]">
          <Sprite
            name="greater-than"
            fill="#1f2730"
            className="absolute -left-10 -top-8 h-[156px] w-[184px] md:-left-16 md:h-[170px] md:w-[200px] lg:-left-28 lg:-top-16 lg:h-[292px] lg:w-[343px] xl:-left-16 xl:-top-8"
          />
          <Sprite
            name="less-than"
            fill="#1f2730"
            className="absolute left-60 top-8 h-[156px] w-[184px] md:-bottom-8 md:left-52 md:top-auto md:h-[170px] md:w-[200px] lg:-bottom-12 lg:left-[26rem] lg:h-[292px] lg:w-[343px]"
          />
        </div>
      </div>
      <div className="zbooni-layout relative flex-1 text-white">
        <div className="mx-auto flex max-w-xs flex-col md:mx-0 md:max-w-none ltr:md:flex-row rtl:md:flex-row-reverse">
          <div className="z-10 flex flex-1 flex-col gap-3 py-10 md:py-24 lg:gap-4 xl:py-32">
            <div
              ref={body}
              data-animation="animate__animated fade-in-slide-down"
              className="flex flex-col gap-3 md:gap-4 rtl:md:mr-14 ltr:lg:ml-20 rtl:lg:mr-20 ltr:xl:ml-32 rtl:xl:mr-40"
            >
              <p className="text-[35px] font-extrabold leading-[42px] md:text-[40px] md:leading-[48px] lg:text-[45px] lg:leading-[54px]">
                <Trans>Use cases.</Trans>
              </p>
              <p className="text-sm font-medium leading-4 md:max-w-[310px] md:text-base md:font-semibold md:leading-6 lg:text-lg">
                <Trans>
                  The possibilities are endless. Here are a few ways to help you
                  get started on using Collections.
                </Trans>
              </p>
            </div>
          </div>
          <div className="flex-1">
            <img
              ref={image}
              data-animation="animate__animated animate__fadeInUp"
              src={handPhoneImg}
              alt="hand holding a phone"
              className="bottom-0 right-7 md:absolute md:w-[418px] lg:right-20 lg:w-[490px] xl:w-[576px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
